'use client';

import { ReactNode } from 'react';
import classnames from 'classnames';

const className = classnames(
  'p-2',
  'bg-card-inset-background-color',
  'text-sm',
  'rounded',
  'text-card-subtitle-color'
);

interface Props {
  children: ReactNode;
}

const PersonalEditorsChoice = ({ children }: Props) => (
  <div className={className}>{children}</div>
);

export default PersonalEditorsChoice;
